import { render, staticRenderFns } from "./RevenueMangerUnitsTable.vue?vue&type=template&id=3de32a46&scoped=true&"
import script from "./RevenueMangerUnitsTable.vue?vue&type=script&lang=js&"
export * from "./RevenueMangerUnitsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de32a46",
  null
  
)

export default component.exports